import type { ChipColorUnion } from '@vk-hr-tek/ui/ColoredChip';

import type { Colors } from '../types';

const BUSINESS_TRIP_START_ATTR_ID = '293864ad-fcba-4bb6-90d9-1c9ee01e53fc';
const BUSINESS_TRIP_END_ATTR_ID = '139ce23d-99be-4d2f-923b-e5738dfb6961';

const FACT_BUSINESS_TRIP_START_ATTR_ID = '04f85d6a-32b5-44e2-a7b8-10445b66805d';
const FACT_BUSINESS_TRIP_END_ATTR_ID = '976b547f-3314-4688-9d39-9077221c4bde';

export const VACATION_START_ATTR_ID = 'b702174b-f9e1-4ec4-97a3-78642eb46e3a';
export const VACATION_END_ATTR_ID = 'b6678658-e673-4782-9d0d-7eb15394d7e5';
export const VACATION_TYPE_ATTR_ID = '68747600-82df-45b2-b434-52bde1cce4e7';

export const FIRST_VACATION_START_ATTR_ID =
  '618b4c3d-b117-411f-b8e0-768ccddcf98a';
export const FIRST_VACATION_END_ATTR_ID =
  '11c46dd8-69c7-4fcb-8d61-f1b998223d7a';
export const FIRST_VACATION_TYPE_ATTR_ID =
  'dffee9c1-960e-40d1-a0b4-2103dfeee570';

export const SECOND_VACATION_START_ATTR_ID =
  'df831f36-2887-4e38-b821-5da41cc79ef2';
export const SECOND_VACATION_END_ATTR_ID =
  '75cf7a13-93cb-4ac0-a404-85baad279f3f';
export const SECOND_VACATION_TYPE_ATTR_ID =
  '0b1ee7ac-4a55-4da4-9a06-9c4e4b94482e';

export const THIRD_VACATION_START_ATTR_ID =
  '164c8694-a803-486e-881c-70e718a39279';
export const THIRD_VACATION_END_ATTR_ID =
  '5e8f489f-7308-4aca-99b9-0e64ad3fdf05';
export const THIRD_VACATION_TYPE_ATTR_ID =
  'a6eba3d1-a2f2-4b4d-a98a-42ea2d702e42';

export const FOURTH_VACATION_START_ATTR_ID =
  '7e5bb0f1-5201-4f36-9b47-9e7d261dd792';
export const FOURTH_VACATION_END_ATTR_ID =
  '1bf5abc2-b941-4958-9ca7-3d002dbd382b';
export const FOURTH_VACATION_TYPE_ATTR_ID =
  '831bdc0d-abd3-44f3-993b-f1a89691342a';

export const FIFTH_VACATION_START_ATTR_ID =
  '007119c9-770f-4ec0-ae08-b924101f448f';
export const FIFTH_VACATION_END_ATTR_ID =
  '4a67438e-024e-4dc9-9a38-4c212ebfdf40';
export const FIFTH_VACATION_TYPE_ATTR_ID =
  '942b3b4c-9430-4b80-ba50-e4ffa986cf95';

export const TRIVIO_FORM_ATTR_ID = '1191e303-31dc-48c2-98fd-3a37fac7efbd';
export const SMARTWAY_FORM_ATTR_ID = 'cdb48364-a1a2-4633-b310-7412e3736a52';
export const VACATION_PLACE_ID = 'c80ffeea-4544-486b-964a-95930caceb1a';
export const COMPENSATION_ID = '6f796e54-8a3a-41ab-a0e8-e579e787f23f';
export const CORTEOS_URL_FORM_ATTR_ID = '60c35a79-fc60-4e38-a277-72e6da3c0dc9';
export const CORTEOS_CHANGE_BUTTON_FORM_ATTR_ID =
  'f8945754-2e43-4abd-90f8-645002af39bf';
export const CORTEOS_HIDE_HEADER_LINK_CHOICE_ATTR_ID =
  'f5bf1326-ba24-4d67-86dd-cebbab919d33';

export const PERIOD_START_ID = '72b3b1e5-5be3-4d3d-bd5e-518e36c93122';
export const PERIOD_END_ID = 'e7df5213-e9d0-476a-8515-cedd2e095c7b';

export const DISMISSAL_DATE_ATTR_ID = '1c639637-69d9-438b-a7c0-9f15e7b40abc';
export const CONTRACT_DATE_ATTR_ID = '8743cbe6-f90e-4c96-a336-c53b6de30873';
export const PLACEMENT_END_DATE_ATTR_ID =
  'd9be5688-cbc4-4339-aeae-6faf96fb2400';
export const PROBATION_START_DATE_ATTR_ID =
  'dfdf18d0-ed25-4f45-8c9d-dde3e4a362b1';
export const PROBATION_END_DATE_ATTR_ID =
  '2f322da4-aed1-43de-a32f-628de6c0cf02';

export const UNIT_ATTR_ID = '617fdea2-dba1-4db0-9296-c8413a20c1e6';

export const ABSENCES_ATTRIBUTE_IDS = [
  VACATION_START_ATTR_ID,
  VACATION_END_ATTR_ID,
  FIRST_VACATION_START_ATTR_ID,
  FIRST_VACATION_END_ATTR_ID,
  SECOND_VACATION_START_ATTR_ID,
  SECOND_VACATION_END_ATTR_ID,
  THIRD_VACATION_START_ATTR_ID,
  THIRD_VACATION_END_ATTR_ID,
  FOURTH_VACATION_START_ATTR_ID,
  FOURTH_VACATION_END_ATTR_ID,
  FIFTH_VACATION_START_ATTR_ID,
  FIFTH_VACATION_END_ATTR_ID,
  BUSINESS_TRIP_START_ATTR_ID,
  BUSINESS_TRIP_END_ATTR_ID,
  FACT_BUSINESS_TRIP_START_ATTR_ID,
  FACT_BUSINESS_TRIP_END_ATTR_ID,
];

export const KONTUR_UNAVAILABLE_LINKS = [
  {
    href: window.REACT_APP_VKHRTEK_STATUS_PAGE_LINK,
    name: 'Статус восстановления сервиса',
  },
  {
    href: window.REACT_APP_VKHRTEK_ABOUT_GOSKEY_LINK,
    name: 'Подробнее об УНЭП Госключ',
  },
].filter((link) => link.href);

export const SHOW_URGENT_EVENTS_LOCAL_STORAGE_KEY = 'showUrgentEvents';

export const EVENT_ACTIVE_NODES_TOPIC = 'event.active_nodes';

export const EVENT_CHANGED_MESSAGE_TYPE = 'event_changed';

export const GOAL_FIELD_TYPES = ['mandatory', 'optional'] as const;

export const ONE_HUNDRED_PERCENT = 100;

export const MAX_GOALS_NUMBER = 7;
export const MIN_GOAL_VALUE = 10;
export const MAX_GOAL_VALUE = 50;

export const FORM_ATTR_MD_SIZE_DESKTOP = 8;
export const FORM_ATTR_MD_SIZE_MOBILE = 6;

export const MAX_CHILDREN_EVENTS_COUNTER_VALUE = 999;

export const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
};

export const STAGE_COLORS: Record<string, ChipColorUnion> = {
  completed: 'green',
  system: 'gray',
  in_paper: 'gray',
  upload: 'orange',
  upload_batch: 'orange',
  accept: 'purple',
  unep_sign: 'blue',
  unep_sign_batch: 'blue',
  ukep_sign: 'blue',
  ukep_sign_batch: 'blue',
  pep_sign: 'blue',
  pep_sign_batch: 'blue',
  default: 'gray',
  competency_eval: 'gray',
  competency_profile: 'blue',
  canceled: 'red',
  canceled_to_paper: 'gray',
  generate_document_from_template: 'orange',
  declined: 'red',
  declined_sign: 'red',
  system_booking_hook: 'gray',
  system_booking_approve: 'purple',
  system_booking_limits_exceeded_approve: 'purple',
  system_linkedtrip_attrinfo: 'gray',
  system_linkedtrip_approveinfo: 'gray',
  system_booking_trip_create: 'gray',
  system_booking_trip_info: 'gray',
  system_booking_trip_change: 'gray',
  system_booking_trip_ordering: 'blue',
  system_booking_trip_limit: 'blue',
  system_booking_trip_limit_approved: 'gray',
  system_create_request_sw: 'gray',
  system_trip_info_sw: 'blue',
  system_cancel_request_sw: 'gray',
  system_item_voucher_sw: 'gray',
  system_business_trip_file_delivery: 'gray',
};

export const BUSINESS_TRIPS_TAG = 'Командировки';

export const GRID_SIZE = 12;
export const ROW_GRID_SIZE_DEFAULT = 6;
export const MAX_LINE_COUNT = 3;
export const ATTRIBUTE_FIELD_HEIGHT = 120;

export const MAX_PERIODS_TO_SHOW = 3;

export const BUSINESS_TRIP_PERIODS = {
  start: [BUSINESS_TRIP_START_ATTR_ID, FACT_BUSINESS_TRIP_START_ATTR_ID],
  end: [BUSINESS_TRIP_END_ATTR_ID, FACT_BUSINESS_TRIP_END_ATTR_ID],
};

export const DOT_BG_COLORS: Colors = {
  grey: 'stroke.secondary',
  purple: 'accent.stroke.review',
  green: 'accent.stroke.success',
  red: 'accent.stroke.error',
};

export const CORTEOS_BUTTON_IDS = [
  CORTEOS_URL_FORM_ATTR_ID,
  CORTEOS_CHANGE_BUTTON_FORM_ATTR_ID,
];

export const VACATION_HEADER_TYPES = [
  'in_paper',
  'completed',
  'canceled',
  'declined',
];
